import { render, staticRenderFns } from "./state.vue?vue&type=template&id=0daa983a&scoped=true"
import script from "./state.vue?vue&type=script&lang=js"
export * from "./state.vue?vue&type=script&lang=js"
import style0 from "./state.vue?vue&type=style&index=0&id=0daa983a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0daa983a",
  null
  
)

export default component.exports